import { useStore } from 'vuex'
import ContentCarousel from '../ContentCarousel/ContentCarousel.vue'
import SliderCardBasic from '../ContentCarousel/cards/SliderCardBasic'

export default {
    name: 'SecondaryArticleSpots',
    components: {
        ContentCarousel,
        SliderCardBasic
    },
    props: {
        contentJson: {
            type: Object,
            required: true
        },
        link: {
            type: Object,
            required: false
        },
        carouselId: {
            type: String,
            required: true
        }
    },
    setup() {
        const store = useStore()
        const getLabel = (labelKey) =>
            store.getters['labels/getLabel']({
                labelCollection: 'secondaryArticleSpots',
                labelKey
            })

        return {
            getLabel,
            ContentCarousel,
            SliderCardBasic
        }
    }
}
